import * as React from 'react'

import { ContractsVersionDocument } from 'generated/resources/graphql'
import moment from 'moment'

import { useQuery } from 'modules/core/hooks/useQuery'

import { ContractVersion } from 'modules/attendance/lib/contractsVersionContext'

import { getReferenceContract } from './contractsVersion'

interface ContextProps {
  loading: boolean
  contract: ContractVersion | undefined
  contracts: ContractVersion[]
  startsOn: moment.Moment | undefined
  endsOn: moment.Moment | undefined
}

const Context = React.createContext<ContextProps>({
  loading: false,
  contract: undefined,
  contracts: [],
  startsOn: undefined,
  endsOn: undefined,
})

export const ContractsVersionProvider = ({
  employeeId,
  children,
}: {
  employeeId: number
  children: React.ReactNode
}) => {
  const { data, loading } = useQuery(ContractsVersionDocument, {
    variables: { employeeId, today: moment().format('YYYY-MM-DD') },
  })

  const contractsVersion = data?.contracts.contractVersionsConnection.nodes ?? []
  const contract = getReferenceContract(contractsVersion)

  return (
    <Context.Provider
      value={{
        loading,
        contract,
        startsOn: !!contract ? moment(contract.startsOn) : undefined,
        endsOn: !!contract ? moment(contract.endsOn) : undefined,
        contracts: contractsVersion,
      }}
    >
      {children}
    </Context.Provider>
  )
}

export const useContractsVersion = (): ContextProps => {
  const ContractsVersion = React.useContext(Context)

  if (!ContractsVersion) {
    throw new Error('useContractsVersion must be used within a ContractsVersionProvider')
  }

  return ContractsVersion
}
